import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';


const restaurantSchema = {
  '@context': 'https://schema.org',
  '@type': 'Restaurant',
  '@id': 'https://www.michelbergerhotel.com/#restaurant',
  name: 'Michelberger Restaurant',
  description: 'Farm-to-table restaurant serving elevated comfort food with seasonal ingredients from the Michelberger Farm food forest in Brandenburg.',
  servesCuisine: ['European', 'Contemporary', 'Farm-to-table'],
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Warschauer Straße 39-40',
    addressLocality: 'Berlin',
    postalCode: '10243',
    addressCountry: 'DE',
  },
  telephone: '+49-30-29778590',
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '07:00', closes: '11:00' },
    { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Saturday', opens: '07:00', closes: '14:00' },
    { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Sunday', opens: '07:00', closes: '15:00' },
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'], opens: '12:00', closes: '14:00' },
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'], opens: '17:30', closes: '23:00' },
  ],
  containedInPlace: {
    '@type': 'Hotel',
    '@id': 'https://www.michelbergerhotel.com/#hotel',
  },
};

const RestaurantSchema = ({ name }) => {
  const schema = name ? { ...restaurantSchema, name } : restaurantSchema;
  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

RestaurantSchema.propTypes = {
  name: PropTypes.string,
};

export default RestaurantSchema;
